var $bfa21259fd564cea$exports = {};
$bfa21259fd564cea$exports = {
    "collapse": ` Skupi`,
    "expand": `Pro\u{161}iri`
};


export {$bfa21259fd564cea$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
